import { Store } from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import SecureLS from 'secure-ls';

export default function (dataStore = {}, key = 'wfh_store') {
    const ls = new SecureLS({ isCompression: false });

    return new Store({
        state: dataStore,

        plugins: [
            createPersistedState({
                key: key,

                storage: {
                    getItem (key) {
                        return ls.get(key);
                    },
                    setItem (key, value) {
                        ls.set(key, value);
                    },
                    removeItem (key) {
                        ls.remove(key);
                    },
                },
            }),
        ],

        mutations: {
            save (state, { key, value }) {
                if (value) {
                    state[key] = value;
                    return;
                }

                state[key] = null;
            },
        },
    });
}
